<div class="container mx-auto ">
    <div class="bg-white">
        <app-header></app-header>
    </div>
</div>

<div class="border-b border-gray-200 shadow-md"></div>

<!-- Bottom Menu for Mobile -->
<app-mobile-menu></app-mobile-menu>

<!-- Hero block for mobile -->

<nav class="bg-menu-100 py-4 hidden sm:block">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col space-y-4">
            <div class="overflow-x-auto scrollbar-hide">
                <ul class="flex justify-start whitespace-nowrap">
                    <li *ngFor="let category of categories" class="hover:text-secondary inline-block mr-4 last:mr-0">
                        <a [routerLink]="['/store', category.slug]" routerLinkActive="active"
                           class="btn btn-ghost hover:bg-transparent">{{category?.title}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>

<div class="border-b border-gray-200 shadow-md"></div>

<div class="bg-stone-50">
    <div class="container mx-auto lg:pt-10 md:pt-10">
        <nav *ngIf="selectedCategory" class="ps-6 hidden sm:flex mb-8" aria-label="Breadcrumb">
            <ol class="flex items-center space-x-4">
                <li>
                    <div class="flex items-center">
                        <a [routerLink]="'/store'"
                            class="text-sm font-medium text-gray-500 hover:text-gray-700">{{'REG_store' |
                            translate}}</a>
                    </div>
                </li>
                <li *ngIf="selectedCategory">
                    <div class="flex items-center">
                        <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clip-rule="evenodd" />
                        </svg>
                        <a [routerLink]="['/store', selectedCategory?.slug]"
                            class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">{{selectedCategory?.title}}</a>
                    </div>
                </li>
                <li *ngIf="storeService.subCategorySubject.getValue()?.title && subcategories">
                    <div class="flex items-center">
                        <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clip-rule="evenodd" />
                        </svg>
                        <a [routerLink]="['/store', selectedCategory?.slug, storeService.subCategorySubject.getValue()?.slug]"
                            aria-current="page"
                            class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700">{{storeService.subCategorySubject.getValue()?.title}}</a>
                    </div>
                </li>
            </ol>
        </nav>

        <div class="lg:grid lg:grid-cols-5 lg:gap-x-8">
            <!-- Sidebar -->
            <aside class="hidden lg:block lg:col-span-1">
                <h2 class="sr-only">Filters</h2>
                <div class="p-6">
                    <h3 class="text-lg font-semibold text-gray-900 mb-4">{{ 'CATEGORIES' | translate }}</h3>
                    <ul class="space-y-4">
                        <li *ngFor="let category of categories">
                            <!-- Category without current slug -->
                            <ng-container *ngIf="category.slug !== categorySlug">
                                <div class="flex items-center justify-between cursor-pointer"
                                     (click)="toggleCategory(category.slug)">
                                    <a [routerLink]="['/store', category.slug]"
                                       class="text-gray-600 hover:text-secondary transition flex-grow">
                                        {{category?.title}}
                                    </a>
                                    <button class="ml-2 focus:outline-none" (click)="toggleCategory(category.slug); $event.preventDefault()">
                                        <i class="fas"
                                           [class.fa-chevron-down]="isExpanded(category.slug)"
                                           [class.fa-chevron-right]="!isExpanded(category.slug)">
                                        </i>
                                    </button>
                                </div>
                            </ng-container>
            
                            <!-- Category with current slug -->
                            <ng-container *ngIf="category.slug === categorySlug">
                                <div class="cursor-pointer" (click)="toggleCategory(category.slug)">
                                    <div class="flex items-center justify-between text-gray-900 font-medium">
                                        <span>{{category?.title}}</span>
                                        <button class="ml-2 focus:outline-none">
                                            <i class="fas"
                                               [class.fa-chevron-down]="isExpanded(category.slug)"
                                               [class.fa-chevron-right]="!isExpanded(category.slug)">
                                            </i>
                                        </button>
                                    </div>
                                </div>
                                
                                <!-- Subcategories -->
                                <ul *ngIf="isExpanded(category.slug)" 
                                    [@slideInOut]
                                    class="mt-2 ml-4 space-y-2">
                                    <li *ngFor="let sub of subcategories">
                                        <a routerLink="../store/{{category?.slug}}/{{sub?.slug}}"
                                           routerLinkActive="text-secondary font-medium"
                                           class="text-gray-600 hover:text-secondary transition">
                                            {{ sub?.title }}
                                        </a>
                                    </li>
                                </ul>
                            </ng-container>
                        </li>
                    </ul>
                </div>
            </aside>
            <!-- Main content -->
            <div class="mt-6 lg:mt-0 lg:col-span-4 bg relative z-10" >
                <section aria-labelledby="product-heading">
                    <router-outlet></router-outlet>
                </section>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>